module.exports = __webpack_public_path__ + "static/media/pre_cast_spr_bea.94b4a76d.png";